const path = "/ava/processos";

const endpoint = {
  processoAberto: `${path}/processos-abertos`,
};

export default endpoint;
